import { Fragment, type ReactNode } from "react";

const SLOT_SPLIT_REGEX = /(\{\w+\})/;
const SLOT_NAME_REGEX = /^\{(\w+)\}$/;

/**
 * Fill `{name}` slots in a translated message with React nodes.
 *
 * Use it when one sentence carries a styled run — an emphasised word, a `<code>` span,
 * a link — that `t()` cannot hold because it returns a string. The sentence stays ONE
 * message, so a translator can move the slot wherever the target grammar wants it.
 * A placeholder with no matching slot is left as visible text, mirroring `t()`.
 */
export function renderSlots(
  template: string,
  slots: Record<string, ReactNode>
): ReactNode {
  return template.split(SLOT_SPLIT_REGEX).map((part, index) => {
    const name = SLOT_NAME_REGEX.exec(part)?.[1];
    const key = `${index}-${part}`;
    if (name !== undefined && name in slots) {
      return <Fragment key={key}>{slots[name]}</Fragment>;
    }
    return <Fragment key={key}>{part}</Fragment>;
  });
}
